<template>
  <div class="fillcontain">
    <search-item @batchSendMessage="batchSendMessage"></search-item>
    <div class="table_container">
      <el-table
        v-loading="loading"
        :data="tableData"
        border
        style="width: 100%"
        align="center"
        @selection-change="handleSelectionChange"
      >
        <el-table-column
          width="50"
          type="selection"
          align="left"
          fit
        ></el-table-column>
        <el-table-column
          prop="name"
          label="会员名称"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="name"
          label="手机号"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="name"
          label="短信类型"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="name"
          label="发送内容"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="name"
          label="发送时间"
          align="center"
        ></el-table-column>
      </el-table>
      <pagination
        :pageTotal="pageTotal"
        @handleCurrentChange="handleCurrentChange"
        @handleSizeChange="handleSizeChange"
      ></pagination>
    </div>
    <div>
      <el-dialog title="批量发送短信" :visible.sync="messageVisible">
        <el-form :model="messageForm" label-width="120px">
          <el-form-item label="短信类型">
            <el-select v-model="messageForm.type" placeholder="请选择短信类型">
              <el-option label="放假通知" value="0"></el-option>
              <el-option label="复课通知" value="1"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="短信内容">
            <el-input v-model="messageForm.content" placeholder="请输入短信内容" type="textarea"></el-input>
          </el-form-item>
          <el-form-item required  label="发送学生">
           <div style="margin-top:5px"><el-transfer filterable v-model="transferChosenData" :data="transferData" :titles="['会员列表','已选会员']"></el-transfer></div>
        </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="messageVisible = false">取 消</el-button>
          <el-button type="primary" @click="sendMessage">确 定</el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import SearchItem from "./components/searchItem";
import Pagination from "@/components/pagination";
import { getSchoolInfo } from "@/api/school";

export default {
  data() {
    return {
      tableData: [],
      tableHeight: 0,
      loading: false,
      multipleSelection: [], //多选的数据
      schoolData: {
        page: 1,
        limit: 20,
      },
      pageTotal: 0,
      messageVisible: false,
      messageForm: {
        type: '',
        content: ''
      },
      //穿梭框
      transferChosenData: [],
      transferData: [],
    };
  },
  components: {
    SearchItem,
    Pagination,
  },
  mounted() {
    this.getSchoolInfo();
  },
  methods: {
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    //获取预约类型列表
    getSchoolInfo() {
      const para = this.schoolData;
      getSchoolInfo(para).then((res) => {
        console.log(res);
        this.loading = false;
        this.pageTotal = res.data.data.total;
        this.tableData = res.data.data.schoolList;
      });
    },
    // 上下分页
    handleCurrentChange(val) {
      this.schoolData.page = val;
      this.getSchoolInfo();
    },
    // 每页显示多少条
    handleSizeChange(val) {
      this.schoolData.limit = val;
      this.getSchoolInfo();
    },
    batchSendMessage() {
      // if(this.multipleSelection.length > 0) {
      //   this.messageVisible = true
      //   console.log(this.multipleSelection,132);
      // }else {
      //   this.$message.error('请选择一条数据')
      // }
      this.messageVisible = true
    },
    sendMessage() {
      console.log(this.transferChosenData,this.messageForm,'发送成功');
      this.$message.success('发送成功')
      this.getSchoolInfo()
      this.messageVisible = false
    }
  },
};
</script>

<style lang="less" scoped>
.table_container {
  padding: 10px;
  background: #fff;
  border-radius: 2px;
}
.el-dialog--small {
  width: 600px !important;
}
.pagination {
  text-align: left;
  margin-top: 10px;
}
</style>


